import { useFormContext } from '@calendly/form';
import classNames from 'classnames';
import { useEffect, forwardRef } from 'react';
import { MANAGED_EVENT_TYPE } from 'constants/event_types';
import { useETEditorFormikPoolingType } from 'services/event_types';
import { useLocationManagement, useOrganizer } from './hooks';
import { Location } from './location';
import { getIsRROrCRRWithoutCollectivePools, getUserPools } from './utils';
const containerIsReadOnlyCss = "c3dli7x";
const containerCss = "c1lg6gsb";
const Container = forwardRef((props, ref) => {
  const {
    isReadOnly,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsReadOnlyCss]: isReadOnly
  }, props.className)} />;
});
const styledLocationCss = "s5tm5yw";
const StyledLocation = forwardRef((props, ref) => <Location ref={ref} {...props} className={classNames(styledLocationCss, props.className)} />);
export const LocationBase = ({
  eventType,
  isManaged,
  isLocked,
  isReadOnly,
  membership,
  startExpanded
}) => {
  const {
    values,
    status
  } = useFormContext();
  const {
    isRoundRobin,
    isCollective,
    isCollectiveRoundRobin
  } = useETEditorFormikPoolingType();
  const userPools = getUserPools(values);
  const isRoundRobinOrCollectiveRoundRobin = getIsRROrCRRWithoutCollectivePools(isRoundRobin, isCollectiveRoundRobin, userPools);
  const {
    allLocations,
    filteredLocations
  } = useLocationManagement(eventType, membership);
  const firstLocationKind = filteredLocations?.[0]?.kind;
  const canCollectiveHaveMultipleLocations = isCollective || userPools.some(pool => pool.pooling_type === 'collective');
  const allowMultiple = eventType.kind_name === 'one_on_one' || eventType.type === MANAGED_EVENT_TYPE && eventType.kind === 'solo' || canCollectiveHaveMultipleLocations;
  const {
    organizableConferenceLocation,
    organizerMemberships,
    currentOrganizer,
    updateOrganizer
  } = useOrganizer(eventType, firstLocationKind, allLocations);
  useEffect(() => {
    const canHaveLocationOrganizer = organizableConferenceLocation && !['google_conference', 'microsoft_teams_conference'].includes(firstLocationKind) && (isCollective || isCollectiveRoundRobin);
    const hasMemberships = organizerMemberships && organizerMemberships.length;
    if (canHaveLocationOrganizer && hasMemberships && !organizerMemberships.some(m => m.location_organizer)) {
      updateOrganizer(organizerMemberships[0]);
    }
  }, [isCollective, isCollectiveRoundRobin, organizableConferenceLocation, firstLocationKind, organizerMemberships, updateOrganizer]);
  return <Container>
      <StyledLocation key={`${status}-LocationBase`} data-testid="location-field" isReadOnly={isReadOnly} eventType={eventType} membership={membership} isManaged={isManaged} conferencingOrganizer={isRoundRobinOrCollectiveRoundRobin ? membership : currentOrganizer} allowMultiple={allowMultiple} isDisabled={isRoundRobinOrCollectiveRoundRobin && !membership.enabled} isLocked={isLocked} startExpanded={startExpanded} />
    </Container>;
};

require("./base.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./base.js");